import { AuthAnalyticsFlowVersion } from './authentication-analytics-context';

export enum SignInDialogVersion {
    V1,
    V2,
}

/** `v1` / `v2`; the enum is numeric. */
export function toFlowVersion(version: SignInDialogVersion): AuthAnalyticsFlowVersion {
    return `v${version + 1}`;
}
